import Report from "../../../../report";
import {ViewType} from "../../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../../@types";
import ReportEffortsDistributionByUser_Settings from "./settings";
import SavedView from "../../../../../saved-view/saved-view";
import ApiView from "../../../../../../gd/api/view";

export default class ReportEffortsDistributionByUser extends Report<ReportEffortsDistributionByUser_Settings> {

    static reportName   : string = "By user"

    declare settings    : ReportEffortsDistributionByUser_Settings

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_EFFORTS_DISTRIBUTION_BY_USER
        super(data);

        this.icon        = "isvg-effort-by-user"
        this.description = "Displays how users allocate their efforts across projects, providing insight into work focus and priorities."

        this.settings    = new ReportEffortsDistributionByUser_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportEffortsDistributionByUser {
        return new ReportEffortsDistributionByUser(savedView)
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportEffortsDistributionByUser_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
